<script>
import options from "./ProductTileGrid.options";
export default options;
</script>

<template>
    <article class="nti-product-tile-grid">
        <section class="nti-product-tile-grid__navigation-container">
            <div class="nti-product-tile-grid__mobile-filter">
                <ShopFilter />
            </div>
            <SortDropdown />
            <FilterPager v-if="!hasError" ref="mainFilterPager" :receivesFocus="true" />
        </section>
        <div v-if="hasError" class="nti-product-tile-grid__error" role="alert">
            <p class="nti-product-tile-grid__error-message">{{ errorMessage }}</p>
            <button class="nti-button" type="button" @click="retry">{{ retryLabel }}</button>
        </div>
        <template v-else>
            <div v-if="hasStaleWarning" class="nti-product-tile-grid__warning" role="status">
                <span class="nti-product-tile-grid__warning-message">{{ staleWarningMessage }}</span>
            </div>
            <div class="nti-product-tile-grid__container">
                <template v-for="data in productCards" :key="data.id">
                    <ProductTile v-if="data" :cardData="data" />
                </template>
            </div>
        </template>
        <section v-if="!hasError" class="nti-product-tile-grid__navigation-container nti-product-tile-grid__navigation-container--bottom">
            <FilterPager />
        </section>
    </article>
</template>

